import styled from 'styled-components'
import ReferralBackground from '../../../images/backgrounds/referralBanner.png'
import theme from '../../../styles/theme'

export const ProgressBox = styled.div`
  height: 295px;
  width: 100%;
  border-radius: 4px;
  background: url(${ReferralBackground}) #000;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: -32px;
  box-sizing: border-box;
  padding-right: 24px;

  @media only screen and (max-width: 1400px) {
    background-position: -100px;
  }

  ${theme.breakpoints.down('sm')} {
    padding: 16px;
    background-position: center;
  }
`

export const ProgressTextBox = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column;
  height: 100%;
  margin-left: 40%;

  @media only screen and (max-width: 1500px) {
    margin-left: 30%;
  }

  ${theme.breakpoints.down('sm')} {
    margin-left: 0;
  }
`

export const Title = styled.p`
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 32px;

  @media only screen and (max-width: 1400px) {
    font-size: 24px;
  }
`

export const Text = styled.p<{$isSubItem?: boolean; margin?: string}>`
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 16px;

  @media only screen and (max-width: 1400px) {
    font-size: 14px;
  }

  ${({$isSubItem}) =>
    $isSubItem
      ? `
        margin-left: 8px;
      `
      : null}

  ${({margin}) =>
    margin === 'first'
      ? `
        margin-top: 24px;
      `
      : margin === 'second'
      ? `
        margin-top: 16px;
      `
      : null}
`

export const ButtonBox = styled.div`
  margin-top: 16px;
  && button {
    width: 140px;
  }

  ${theme.breakpoints.down('sm')} {
    && button {
      width: 100% !important;
    }
  }
`
